import { FC, useContext } from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { JournalEntriesContext } from '../../../../context/JournalEntriesContext'
import { EntryFilterType } from '../../../../interfaceTypes/journalEntries'

const EntryTypeFilter: FC = () => {
  const { filters, setFilters } = useContext(JournalEntriesContext)

  const handleTypeChange = (value: EntryFilterType) => {
    setFilters({ type: value })
  }

  return (
    <FormControl sx={{ minWidth: 170 }}>
      <InputLabel>Type</InputLabel>
      <Select value={filters.type} label="Type" onChange={e => handleTypeChange(e.target.value as EntryFilterType)}>
        <MenuItem value="all">All</MenuItem>
        <MenuItem value="manual">Manual Entries</MenuItem>
        <MenuItem value="system">System Generated</MenuItem>
      </Select>
    </FormControl>
  )
}

export default EntryTypeFilter
